// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Toggletip-components-ToggletipContent-ToggletipContent-module__content";
var _2 = "webpack-components-core-Toggletip-components-ToggletipContent-ToggletipContent-module__dark";
export { _1 as "content", _2 as "dark" }
